import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "512",
  height: "512",
  viewBox: "0 0 520 520"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "11-Checked" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#b0ef8f",
    d: "M260 488A228 228 0 0 1 98.78 98.78a228 228 0 1 1 322.44 322.44A226.5 226.5 0 0 1 260 488z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#009045",
    d: "M214.5 387.781 97.5 270.8l47.561-47.56 69.428 69.428 160.45-160.45 47.561 47.56z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }